function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { ROLES_LIST, PERIODS, PATTERNS_VALIDATION } from '@/js/constants';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ''
    },
    classstyle: {
      type: String,
      default: 'col'
    },
    hide_details: {
      type: String,
      default: ''
    },
    value: {
      required: true
    },
    validate_domain: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      model: this.value,
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      incorrect_emails: {},
      errors_recipients: [],
      rules: [function (v) {
        return v == "" || v == undefined || v == null || v == [] || _this.ruleEmailMultiSelect || Object.keys(_this.incorrect_emails).length == 0 || 'Formato Incorrecto';
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc'])), {}, {
    computedPlaceholder: function computedPlaceholder() {
      if (this.placeholder) return this.placeholder;
      return this.model && this.model.length > 0 ? 'Agregar otro correo...' : 'ejemplo@empresa.com';
    },
    computedHint: function computedHint() {
      if (this.errors_recipients.length > 0) return '';
      return 'Separa correos con Enter, Espacio o Comas. Puedes pegar múltiples correos a la vez.';
    },
    ruleEmailMultiSelect: function ruleEmailMultiSelect() {
      var _this2 = this;
      if (this.model && this.model.length === 0) {
        return true;
      } else if (this.model && this.model.length > 0) {
        var invalids = 0;
        this.model.forEach(function (value) {
          var last_input = value;
          var regexValidation = _this2.emailPattern.test(last_input);
          if (!regexValidation) {
            invalids += 1;
          }
        });
        return invalids == 0;
      } else {
        return true;
      }
    }
  }),
  watch: {
    model: function model(newValue) {
      this.$emit('input', newValue.value ? newValue.value : newValue);
      this.$emit('change');
    },
    value: function value(newValue) {
      this.model = newValue.value ? newValue.value : newValue;
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    isValidEmail: function isValidEmail(email) {
      return this.emailPattern.test(email) && !this.incorrect_emails[email];
    },
    addEmail: function addEmail(event) {
      var input = event.target.value;
      if (!input || input.trim() === '') return;

      // Separa por comas, espacios o saltos de línea
      var emails = input.split(/[,;\s\n]+/).map(function (e) {
        return e.trim();
      }).filter(function (e) {
        return e !== '';
      });
      if (emails.length > 0) {
        // Agrega todos los emails extraídos
        var uniqueEmails = _toConsumableArray(new Set([].concat(_toConsumableArray(this.model || []), _toConsumableArray(emails))));
        this.model = uniqueEmails;

        // Limpia el input
        event.target.value = '';

        // Valida
        this.onChangeRecipients();
      }
    },
    onPaste: function onPaste(event) {
      event.preventDefault();
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');

      // Separa por comas, espacios, saltos de línea
      var emails = pastedText.split(/[,;\s\n]+/).map(function (e) {
        return e.trim();
      }).filter(function (e) {
        return e !== '';
      });
      if (emails.length > 0) {
        var uniqueEmails = _toConsumableArray(new Set([].concat(_toConsumableArray(this.model || []), _toConsumableArray(emails))));
        this.model = uniqueEmails;
        this.onChangeRecipients();
      }
    },
    onChangeRecipients: function onChangeRecipients(event) {
      var _this3 = this;
      var deleted = [];
      this.errors_recipients = [];
      if (this.model && this.model.length > 0) {
        this.model.forEach(function (email) {
          var regexValidation = _this3.emailPattern.test(email);
          if (!regexValidation) {
            _this3.incorrect_emails[email] = 1;
          }
        });
        Object.keys(this.incorrect_emails).forEach(function (e) {
          if (_this3.model.indexOf(e) == -1) {
            deleted.push(e);
          }
        });

        // delete keys
        deleted.forEach(function (item) {
          try {
            delete _this3.incorrect_emails[item];
          } catch (e) {}
        });
        if (Object.keys(this.incorrect_emails).length > 0) {
          var invalidEmails = Object.keys(this.incorrect_emails).join(', ');
          this.errors_recipients = ["Correos inv\xE1lidos: ".concat(invalidEmails)];
        } else if (this.validate_domain && this.model.length > 0) {
          this.validateDomainEmail(this.model[this.model.length - 1]);
        }
      } else {
        this.incorrect_emails = {};
      }
    },
    validateDomainEmail: function validateDomainEmail(email) {
      var _this4 = this;
      var regexValidation = this.emailPattern.test(email);
      if (!regexValidation) {
        this.errors_recipients = [this.traductor('reglas.wrong_emails')];
        return;
      }
      var params = {
        email: email
      };
      return UserSecurityService.getDomainUser(params).then(function (response) {
        var domain = response.data.domain;
        if (_this4.orgs.findIndex(function (item) {
          return item.domain === domain;
        }) === -1) {
          _this4.errors_recipients = ['Correo no válido en la organización'];
          _this4.incorrect_emails[email] = 1;
          return;
        }
        if (domain !== window.userInfo.domain) {
          _this4.errors_recipients = ['El usuario no se encuentra en la empresa actual.'];
          _this4.incorrect_emails[email] = 1;
          return;
        }
      }).catch(function (err) {
        console.error('Error validando dominio:', err);
      });
    }
  }
};